import React from "react";

const LocationIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 14V16C10.4087 16 8.88258 16.6321 7.75736 17.7574C6.63214 18.8826 6 20.4087 6 22H4C4 19.8783 4.84285 17.8434 6.34315 16.3431C7.84344 14.8429 9.87827 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM20.828 21.071L18 24L15.172 21.071C13.609 19.453 13.609 16.831 15.172 15.213C15.5366 14.8298 15.9754 14.5248 16.4615 14.3163C16.9476 14.1079 17.4711 14.0004 18 14.0004C18.5289 14.0004 19.0524 14.1079 19.5385 14.3163C20.0246 14.5248 20.4633 14.8298 20.828 15.213C22.391 16.831 22.391 19.453 20.828 21.071ZM19.39 19.681C20.203 18.839 20.203 17.445 19.39 16.603C19.2119 16.4127 18.9966 16.2611 18.7575 16.1574C18.5184 16.0537 18.2606 16.0002 18 16.0002C17.7394 16.0002 17.4816 16.0537 17.2425 16.1574C17.0034 16.2611 16.7881 16.4127 16.61 16.603C15.797 17.445 15.797 18.839 16.61 19.682L18 21.12L19.39 19.68V19.681Z"
        fill="#03053D"
      />
    </svg>
  );
};

export default LocationIcon;
